import { NoneValueSignal } from "../../signal/NoneValueSignal";
import { BasicButtonValueContainer } from "./display/basic/BasicButtonValueContainer";
import { BasicSliderValueContainer } from "./display/basic/BasicSliderValueContainer";
import { BasicTextfieldValueContainer } from "./display/basic/BasicTextfieldValueContainer";
import { AValueComponent } from "./AValueComponent";
import { InputTextfieldValueComponent } from "./InputTextfieldValueComponent";
import { ButtonsValueComponent } from "./ButtonsValueComponent";
import { SliderValueComponent } from "./SliderValueComponent";

import MovieClip = createjs.MovieClip;
import { TextField } from "@goodgamestudios/createjs-utilities";

export class ValueChangerController {
    private _elements: AValueComponent[];
    protected _value: number = 15;
    protected _minValue: number;
    protected _maxValue: number;
    public valueUpdatedSignal: NoneValueSignal = new NoneValueSignal();

    constructor(startValue: number, minValue: number, maxValue: number) {
        this._elements = [];
        this._value = startValue;
        this._minValue = minValue;
        this._maxValue = maxValue;
    }

    public addValueComponent(element: AValueComponent): void {
        this._elements.push(element);
        element.updatedByUserSignal.add(this.bindFunction(this.userChangedData));
        element.updateValue(this._value);
    }

    protected userChangedData(newValue: number): void {
        this.verifyInput(newValue);

        for (let i: number = 0; i < this._elements.length; i++) {
            this._elements[i].updateValue(this._value);
        }

        this.valueUpdatedSignal.signal();
    }

    protected verifyInput(newValue: number): void {
        if (newValue < this._minValue) {
            this._value = this._minValue;
        }
        else if (newValue > this._maxValue) {
            this._value = this._maxValue;
        }
        else {
            this._value = newValue;
        }
    }

    public addTextfield(textfield: TextField): void {
        let textFieldContainer: BasicTextfieldValueContainer = new BasicTextfieldValueContainer(textfield);
        let textFieldComp: InputTextfieldValueComponent = new InputTextfieldValueComponent(this, this._minValue, this._maxValue, textFieldContainer);
        this.addValueComponent(textFieldComp);
    }

    public addButtons(buttonParentMovieClip: MovieClip, stepSize: number): void {
        let btnContainer: BasicButtonValueContainer = new BasicButtonValueContainer(buttonParentMovieClip);
        let buttonsComp: ButtonsValueComponent = new ButtonsValueComponent(this, this._minValue, this._maxValue, btnContainer, stepSize);
        this.addValueComponent(buttonsComp);
    }

    public dispose(): void {
        for (let i: number = 0; i < this._elements.length; i++) {
            this._elements[i].dispose();
        }
        this.valueUpdatedSignal.removeAll();
    }

    public addSlider(slider: MovieClip): void {
        let sliderContainer: BasicSliderValueContainer = new BasicSliderValueContainer(slider);
        let sliderComp: SliderValueComponent = new SliderValueComponent(this, this._minValue, this._maxValue, sliderContainer);
        this.addValueComponent(sliderComp);
    }

    public get value(): number {
        return this._value;
    }
}
